export default __webpack_public_path__ + "static/media/feature-details-page.b4696014.png";